import { ArrowLeft } from 'lucide-react'
import Image from 'next/image'
import Link from 'next/link'

export function StepHeader({ showBack, onBack }: { showBack: boolean; onBack?: () => void }) {
	return (
		<div className="flex items-center justify-center">
			{showBack ? (
				<button
					type="button"
					onClick={onBack}
					className="absolute left-[24px] cursor-pointer text-brand-gray-secondary transition-colors hover:text-white"
				>
					<ArrowLeft className="size-[24px]" />
				</button>
			) : null}
			<Link href="/">
				<Image src="/logos/logo.png" alt="Chance" width={109} height={24} className="w-auto" />
			</Link>
		</div>
	)
}
